import { Form, NumberBox, SelectBox, TextBox } from 'devextreme-react';
import { ButtonItem, EmptyItem, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';
import { apiGetP, apiPostP } from '../../GanjiTools';
import { UniGrid } from '../UniGrid';
import ExportTool from './ExportTool';
import SideDivider from '../layout/SideDivider';
import CollapsibleBox from '../utils/CollapsibleBox';
import { style } from 'typestyle';
import Theme from '../theme/Theme';

class CustomerReports extends Component {
    state = {
        customer: this.props.customer,
        //customersLookup: window.customersLookup ?? [],
        loading: true,
    }

    static fetchCustomersLookupP(forceReload) {
        return new Promise((resolve, reject) => {
            if (!forceReload && window.customersLookup?.length > 0) {
                resolve?.(window.customersLookup);
                return;
            }
            apiPostP('/api/dyna/rowsAsLookup/Customer', {})
                .then(res => {
                    let { list, error } = res ?? { error: 'No response' };
                    if (error?.length > 0) {
                        reject?.(error);
                        return;
                    }
                    window.customersLookup = list;
                    console.log('customersLookup=', window.customersLookup);
                    resolve?.(list);
                }).catch(reject)
        });
    }

    loadCustomerReport = id => {
        apiGetP(`/api/tarabar/report/customer/${id}`)
            .then(res => {
                let { error, ins, outs } = res ?? { error: 'No response.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ totalMoneyIn: ins, totalMoneyOut: outs, moneyBalance: ins - outs })
            })
            .catch(window.notif);

    }

    onSelectedCustomerChanged = id => {
        this.setState({ customer: window.customersLookup.find(x => x.id === id) }, () => this.loadCustomerReport(id));
    }

    componentDidMount() {
        CustomerReports.fetchCustomersLookupP(true)
            .then(() => this.setState({ loading: false }))
            .catch(window.notif);
        //.then(customersLookup => this.setState({ customersLookup }));
    }

    render() {
        if (this.state.loading)
            return (
                <p style={{ padding: '3rem' }}> صبر کنید...</p>
            );

        let title = 'نمایش سوابق', summary = '', width = this.props.width ?? `${SideDivider.bodyWidth - 150}px`;

        return (
            <div style={{ padding: '0 3rem' }}>
                <CollapsibleBox className={'loadorder-collapsibleboxd ' +
                    style({
                        background: Theme.col1('whitesmoke'),
                        borderRadius: '1rem',
                        color: Theme.col0()
                    })
                }
                    style={{ width, margin: this.props.collapsed ? '2px auto' : '1rem auto' }}

                    title={
                        <div className='loadorder-title'
                            style={{
                                height: '100%', display: 'flex', color: Theme.col0('steelblue'), // ,
                                justifyContent: 'center', alignItems: 'center', fontWeight: '700',
                            }}
                        >
                            <span style={{ fontWeight: '900' }}>{title}</span>
                        </div>
                    }
                    headerStyle={{
                        width: `calc(${width} - ${this.props.wizardMode ? -2 : 2}rem)`,
                        background: Theme.col1('whitesmoke'),
                        color: Theme.col0(),
                    }}
                    summary={
                        <span className='loadorder-summary'
                            style={{
                                margin: '0 1rem',
                                fontSize: '0.8rem',
                                color: Theme.col2('#550')
                            }}
                        >
                            {!Array.isArray(summary) ? summary : Card.renderCards('', summary)}
                        </span>
                    }

                    bodyStyle={{
                        ...this.props.style, ...this.stl, marginTop: '0',
                        borderRadius: /*this.props.collapsed ? '0' :*/ '0 0 1rem 1rem',
                        width: `calc(${width} - 2rem)`,
                        background: Theme.col1('whitesmoke'),
                    }}>
                    <Form rtlEnabled colCount={60} width={`calc(${width} - 3rem)`}>
                        <SimpleItem colSpan={60} label={{ text: 'انتخاب مشتری' }}>
                            <SelectBox rtlEnabled items={window.customersLookup} valueExpr='id' displayExpr='summary'
                                value={this.state.customer?.id}
                                onValueChanged={e => this.onSelectedCustomerChanged(e.value)}
                            />
                        </SimpleItem>

                        <SimpleItem colSpan={60}>
                            <UniGrid table='Mission' readOnly noMetaGrid title='مأموریت ها'
                                //field='fK_Customer' equalTo={this.state.customer?.id}
                                fieldEqualities={{ fK_ToCustomer: `=${this.state.customer?.id ?? 0}` }}
                                showFields={['fK_Remittance', 'fK_Material', 'fK_FromPoint', 'fK_ToPoint', 'tonnage', 'phee', 'pheeUnit']}
                            />
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        <SimpleItem colSpan={60}>
                            <UniGrid table='Deal' readOnly noMetaGrid title='معاملات'
                                //field='fK_Customer' equalTo={this.state.customer?.id}
                                fieldEqualities={{ fK_Customer: `=${this.state.customer?.id ?? 0}` }}
                                hideFields={['fK_Customer', 'fK_Driver', 'fK_Tanker', 'ware', 'date']}
                            />
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        <SimpleItem label={{ text: 'مجموع واریزی ها' }} colSpan={30}>
                            <NumberBox readOnly key={'nbi_' + this.state.totalMoneyIn}
                                value={this.state.totalMoneyIn ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'مجموع برداشت ها' }} colSpan={30}>
                            <NumberBox readOnly key={'nbo_' + this.state.totalMoneyOut}
                                value={this.state.totalMoneyOut ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'تراز مالی' }} colSpan={60}>
                            <NumberBox readOnly
                                value={this.state.moneyBalance ?? 0}
                            />
                        </SimpleItem>
                    </Form>
                </CollapsibleBox>

                <div style={{ margin: '2rem 0 1rem 0', color: 'gray' }}>
                </div>

                <ExportTool table='deal' width={width} fileName='گزارش مشتری'
                    excludeFields={['fK_Tanker', 'fK_Driver', 'fK_Customer', 'dealType']}
                    extraFieldEqualities={[
                        { name: `dealType in (2,3) and fK_Customer = ${this.state.customer?.id ?? 'NULL'}`, oper: 'pre_rendered' },
                    ]}
                />
            </div>
        );
    }
}

export default CustomerReports;